export default __webpack_public_path__ + "static/media/vip-icon.ddb4910e.webp";